module.exports = __webpack_public_path__ + "static/media/230108_ff1_mockup.919d7803.png";